import type { LoginRequest, User } from '../../../domain/models/user'
import * as types from '../types/login-types'

export const loginRequest = (payload: LoginRequest) => ({
  type: types.LOGIN_REQUEST,
  payload,
})

export const loginError = (payload: string) => ({
  type: types.LOGIN_ERROR,
  payload,
})

export const loginSuccess = (payload: User) => ({
  type: types.LOGIN_SUCCESS,
  payload,
})

export const loginReset = ({ resetAll = true }) => ({
  type: types.LOGIN_RESET,
  payload: resetAll,
})

export const loginUpdate = (payload: Partial<LoginRequest>) => ({
  type: types.LOGIN_UPDATE,
  payload,
})
